export class ApiError extends Error {
  status: number;
  payload: unknown;
  constructor(status: number, message: string, payload?: unknown) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

/** Rückfrage bei Änderungen an abgeschlossenen Steuerjahren (409 mit `abgeschlossen`): einmal zentral — der Dialog (AbschlussRueckfrage) fragt,
 *  bei „trotzdem speichern“ wird dieselbe Anfrage mit ?trotzdem=1 wiederholt. Ohne Dialog bleibt es beim Fehler. */
export type Rueckfrage = (p: { error: string; abgeschlossen: number[] }) => Promise<boolean>;
let rueckfrage: Rueckfrage | null = null;
export function setzeRueckfrage(fn: Rueckfrage | null): void { rueckfrage = fn; }

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(path, {
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      ...(init.headers ?? {}),
    },
    ...init,
  });
  let body: unknown = null;
  const text = await res.text();
  if (text) {
    try { body = JSON.parse(text); } catch { body = text; }
  }
  if (res.status === 409 && rueckfrage && body && typeof body === "object" && Array.isArray((body as { abgeschlossen?: unknown }).abgeschlossen)
    && !/[?&]trotzdem=1/.test(path)) {
    if (await rueckfrage(body as { error: string; abgeschlossen: number[] })) return request<T>(`${path}${path.includes("?") ? "&" : "?"}trotzdem=1`, init);
  }
  if (!res.ok) {
    const msg = (body && typeof body === "object" && "error" in (body as Record<string, unknown>))
      ? String((body as Record<string, unknown>).error)
      : `HTTP ${res.status}`;
    throw new ApiError(res.status, msg, body);
  }
  return body as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: "POST", body: body ? JSON.stringify(body) : undefined }),
  patch: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: "PATCH", body: body ? JSON.stringify(body) : undefined }),
  del: <T>(path: string) => request<T>(path, { method: "DELETE" }),
  put: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: "PUT", body: body === undefined ? undefined : JSON.stringify(body) }),
};
